(function (doc, win) {

    var u = navigator.userAgent;
    var ua = u.toLowerCase();

    var versions = { // 移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, // android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1 , // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        isWebChat: ua.match(/MicroMessenger/i) == "micromessenger"  // 是否是微信
    }

    var docEl = doc.documentElement,
    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
    recalc = function () {
        var clientWidth = docEl.clientWidth
        if (!clientWidth) return;
        // if (clientWidth >= 750) {
        //     docEl.style.fontSize = '75px'
        // } else {
        //     docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        // }
        if (versions.mobile && !versions.iPad) {
          docEl.style.fontSize = 100 * (clientWidth / 750) + 'px'
        } else if (clientWidth >= 750){
          docEl.style.fontSize = '100px'
        }
    }

    win.onresize = function () {
      recalc();
    }

    if (!doc.addEventListener) return
    win.addEventListener(resizeEvt, recalc, false)
    doc.addEventListener('DOMContentLoaded', recalc, false)
  })(document, window)


// WEBPACK FOOTER //
// ./src/utlis/set-font-size.js